import { forwardRef, type InputHTMLAttributes } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid, className, ...rest },
  ref,
) {
  const cls = [
    // 40px tap target, soft focus ring tinted from the brand token.
    'block h-10 w-full rounded-md border bg-bg px-3 text-sm text-fg outline-none transition',
    'placeholder:text-fg-muted',
    invalid
      ? 'border-danger focus:border-danger focus:ring-2 focus:ring-danger/20'
      : 'border-border focus:border-brand focus:ring-2 focus:ring-brand/20',
    'disabled:cursor-not-allowed disabled:bg-bg-subtle disabled:opacity-60',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');
  return <input ref={ref} className={cls} aria-invalid={invalid || undefined} {...rest} />;
});
